// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__32Su9","ranges":"BmiRanges_ranges__1TzjT"};